import { AuthObject } from './interfaces';

const STORAGE_KEY = 'auth';

export const saveAuthToStorage = (auth: AuthObject): void => {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(auth));
};

export const getAuthFromStorage = (): AuthObject => {
  const item = window.localStorage.getItem(STORAGE_KEY);

  if (item) {
    return JSON.parse(item);
  } else {
    throw new Error('No auth object found in local storage.');
  }
};

export const clearAuthFromStorage = (): void => {
  window.localStorage.removeItem(STORAGE_KEY);
};
